module.exports = __webpack_public_path__ + "static/klimaatverandering-droogte-nederland-8105638e0b51fadb346cfab50b7a9173.jpg";